export const monetFeatureConfig = {
  raffleCreateUser: true,
  raffleCreateCommunity: true,
  raffleEditCommunity: true,
  wlCreateCommunity: true,
  communityCreate: true,
  ticketSale: true
};